import type { ChatMessage } from '../types/chat'

/** Coerce chat/API text to string before `.trim()` / `.toLowerCase()`. */
export function chatContentString(content: unknown): string {
  if (typeof content === 'string') return content
  if (content == null) return ''
  if (typeof content === 'number' || typeof content === 'boolean') return String(content)
  if (typeof content === 'object') {
    const o = content as Record<string, unknown>
    for (const key of ['text', 'message', 'en', 'fr', 'body', 'content'] as const) {
      const v = o[key]
      if (typeof v === 'string' && v.trim()) return v
    }
  }
  const s = String(content)
  return s === '[object Object]' ? '' : s
}

export function chatContentTrim(content: unknown): string {
  return chatContentString(content).trim()
}

/** Ensure every row has string `content` so MessageList never throws on `.trim()`. */
export function normalizeChatMessagesForDisplay(messages: readonly ChatMessage[]): ChatMessage[] {
  return messages.map((m) =>
    typeof m.content === 'string' ? m : { ...m, content: chatContentString(m.content) },
  )
}
